export const TEMPLATES_NOT_FOUND_ERROR =
  'There are no templates available, please contact your template admin to confirm';
